import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import {
    Spin,
    Modal,
    Form,
    Row,
    Col,
    Alert,
    Checkbox,
    Table,
    Empty, Input
} from 'antd';

// Selectors
import { getDeviceTypesList, getAllDeviceTypesAreLoading } from '../../data/deviceTypes/selectors';
import { getPreselectedMeterId, selectedLangageSelector } from '../../data/app/selector';

// Actions

// Constants
import { MODAL_SIZES } from '../../constants/modal';
import { getAssistantEventsIsLoading, getAssistantList } from '../../data/training/selectors';
import { storeAssistantEvents } from '../../data/training/actions';
import { getSelectedMeter } from '../../data/meters/selectors';

class ChangeEvent extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            assistantEvent: null,
        };
    }

    handleSubmit = () => {
        const { assistant, storeAssistantEvents, selectedMeterId, onSave, form} = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            assistant.meterShortName = values.meterShortName;
        });

        storeAssistantEvents(selectedMeterId, assistant, onSave);
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    handleCheckboxChange = (event) => {
        event.target.record.selected = !event.target.record.selected;
        this.setState({
            assistantEvent: event
        });
        // eslint-disable-next-line react/destructuring-assignment
        console.log(`handleCheckboxChange new value: ${  this.state.assistantEvent}`);
    }

    render() {
        const {
            form,
            isShown,
            msgs,
            onCancel,
            assistantEventsIsLoading,
            assistant,
            selectedMeter,
        } = this.props;
        const { getFieldValue, getFieldDecorator } = form;
        if (selectedMeter && assistant && !assistant.meterShortName) {
            assistant.meterShortName = selectedMeter.name.substring(0, 6);
        }
        const columns = [
            {
                title: msgs.training.recognitionTblNameCol,
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: msgs.training.recognitionTblCountCol,
                dataIndex: 'count',
                key: 'count'
            },
            {
                title: msgs.training.kwhUnit,
                dataIndex: 'kWh',
                key: 'kWh',
            },
            {
                title: msgs.training.recognitionTblPercentCol,
                dataIndex: 'percent',
                key: 'percent'
            },
            {
                title: msgs.training.recognitionTblSelectedCol,
                dataIndex: 'selected',
                key: 'selected',
                render: (text, record) =>
                    (
                        <Checkbox
                            checked={record.selected}
                            onChange={this.handleCheckboxChange}
                            record={record}
                        />
                    )
            }
        ];

        return (
            <Modal
                key="users-modal-change-event"
                visible={isShown}
                confirmLoading={assistantEventsIsLoading}
                width={MODAL_SIZES.LARGE}
                title={msgs.training.deviceAssistant}
                onCancel={onCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.save}
            >
                <Spin spinning={assistantEventsIsLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Form.Item label={msgs.training.meterShortName}>
                            {getFieldDecorator('meterShortName', {
                                initialValue: assistant ? assistant.meterShortName : undefined,
                            })(<Input type="text" maxLength={6} size={Input.small}/>)}
                        </Form.Item>
                        {(assistant && assistant.list && assistant.list.length > 0) ? (
                            <Table pagination={false} dataSource={assistant.list} columns={columns} rowKey='deviceId'/>
                        ) : (
                            <Empty
                                description={<span>{msgs.noDataAvailable}</span>}
                                style={{ margin: '30px auto' }}
                            />
                        )}

                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        selectedMeter: getSelectedMeter(state),
        selectedMeterId: getPreselectedMeterId(state),
        assistantEventsIsLoading: getAssistantEventsIsLoading(state),
        assistant: getAssistantList(state),
        deviceTypesList: getDeviceTypesList(state),
        deviceTypesListIsLoading: getAllDeviceTypesAreLoading(state),
        lang: selectedLangageSelector(state)
    }),
    {
        storeAssistantEvents,
    }
)(Form.create()(ChangeEvent));
